<template>
    <div id="Gaiptal">
        <div id="icerik">
            <div id="logo">
                <img src="https://static.supsis.live/common/image/betnanoLogo.svg" />
            </div>

            <div id="banner">
                <div class="header-content">
                    <div class="header-text-one">
                        Taleplerinize mail yoluyla ya da site içi mesaj aracılığıyla dönüş sağlanmaktadır. Bu sebeple
                        kullanıcı adınızı ve mail adresinizi doğru şekilde iletmenizi rica ederiz.
                    </div>
                    <div class="header-text-two">
                        Betnano S.O.S 24 saat hizmet vermektedir.
                    </div>
                </div>
                <div class="nano-sos-text">
                    NANO S.O.S
                </div>
            </div>
            <div style="margin-top: -30px;" class="content">
                <div class="container-header">
                    <img src="../assets/bgTop.png">
                </div>
                <div id="sari-kutu">
                    <div class="input-group">
                        <div :class="['input-wrapper', { error: showError }]">
                            <div class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#000000" width="24px"
                                     height="24px">
                                    <path d="M0 0h24v24H0z" fill="none" />
                                    <path
                                        d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                                </svg>
                            </div>
                            <input class="special-input" type="text" placeholder="Kullanıcı Adınız"
                                   v-model="username" />
                        </div>
                        <div :class="['input-wrapper', { error: showError }]">
                            <div class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#000000" width="24px"
                                     height="24px">
                                    <path d="M0 0h24v24H0z" fill="none" />
                                    <path
                                        d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                                </svg>
                            </div>
                            <input class="special-input" type="text" placeholder="Adınız & Soyadınız"
                                   v-model="fullName" />
                        </div>
                    </div>
                    <div class="container-title">
                        <span style="margin-top: 8px;">DESTEK TÜRÜNÜ SEÇİNİZ</span>
                    </div>
                    <div class="btn-group">
                        <div class="btn-group-left">
                            <div class="btn-left-img" @click="navigateTo('/GAIptal')">
                                <div class="text">"GA" <br> İPTAL ETME</div>
                            </div>
                            <div class="btn-left-img" @click="navigateTo('/bGuncelleme')">
                                <div class="text">BİLGİ <br> GÜNCELLEME</div>
                            </div>
                            <div class="btn-left-img" @click="navigateTo('/paraYatirmaSorunlari')">
                                <div class="text">PARA YATIRMA <br> SORUNLARI</div>
                            </div>
                        </div>
                        <div class="btn-group-right">
                            <div class="btn-right-img" @click="navigateTo('/hAktivasyonu')">
                                <div class="text">HESAP AKTİVASYONU</div>
                            </div>
                            <div class="btn-right-img" @click="navigateTo('/sifreSifirlamaMenu')">
                                <div class="text">ŞİFRE SIFIRLAMA <br> YAPAMIYORUM</div>
                            </div>
                            <div class="btn-right-img" @click="navigateTo('/sporCasinoCozumleri')">
                                <div class="text">SPOR & CASİNO <br> ÇÖZÜMLERİ</div>
                            </div>
                        </div>
                    </div>
<!--                    <div class="btn-nano-guard" @click="newLink">-->
<!--                        <div class="text">NANO GUARD <br> "GİZLİ ÜYELİK"</div>-->
<!--                    </div>-->
                    <div class="sponsor">
                        <img src="../assets/la-liga.png" alt="Roberto Carlos"
                             style="width: 100px;object-fit: contain;" />
                        <img src="../assets/Sevilla-Site-Tekli.png" alt="Roberto Carlos"
                             style="width: 100px;object-fit: contain;" />
                        <img src="../assets/real-madrid.png" alt="Roberto Carlos" style="width: 100px;object-fit: contain;" />
                        <img src="../assets/lille.png" alt="Roberto Carlos"
                             style="width: 100px;object-fit: contain;" />
                    </div>
                    <div class="social-media-icon">
                        <div>
                            <a href=" https://t.me/Nano_news_turkiye" target="_blank">
                                <img src="../assets/telegramIcon.svg">
                            </a>
                        </div>
                        <div>
                            <a href="https://x.com/BnanoNewsTR " target="_blank">
                                <img src="../assets/twitIcon.svg">
                            </a>
                        </div>
                        <div>
                            <a href="https://www.youtube.com/@NanoNewsTR" target="_blank">
                                <img src="../assets/youtubeIcon.svg">
                            </a>
                        </div>
                        <div>
                            <a href="https://www.instagram.com/nanonewsturkiye/" target="_blank">
                                <img src="../assets/instagramIcon.svg">
                            </a>
                        </div>
                        <div>
                            <a href="https://whatsapp.com/channel/0029VbBaCntICVfsp9TNWS40" target="_blank">
                                <img src="../assets/whatsappIcon.svg">
                            </a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BetnanoLogin",
    data() {
        return {
            username: "",
            fullName: "",
            showError: false,
        };
    },
    mounted() {
        const savedUsername = localStorage.getItem("username");
        const savedFullName = localStorage.getItem("fullName");

        if (savedUsername) {
            this.username = savedUsername;
        }

        if (savedFullName) {
            this.fullName = savedFullName;
        }
    },
    watch: {
        username(newVal) {
            localStorage.setItem("username", newVal);
        },
        fullName(newVal) {
            localStorage.setItem("fullName", newVal);
        },
    },
    methods: {
        navigateTo(route) {
            if (!this.username || !this.fullName) {
                this.showError = true;
            } else {
                this.showError = false;
                this.$router.push({
                    path: route,
                    query: { username: this.username, fullName: this.fullName },
                });
            }
        },
        newLink() {
            window.open("https://bnnanoguard.com/", "_blank");
        },
    },
};
</script>

<style lang="scss" scoped>
/* Custom scroll bar styles - sadece belirli elementler için */
.sponsor::-webkit-scrollbar,
.social-media-icon::-webkit-scrollbar,
.btn-group::-webkit-scrollbar {
    width: 3px;
    height: 3px;
}

.sponsor::-webkit-scrollbar-track,
.social-media-icon::-webkit-scrollbar-track,
.btn-group::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 2px;
}

.sponsor::-webkit-scrollbar-thumb,
.social-media-icon::-webkit-scrollbar-thumb,
.btn-group::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.6);
    border-radius: 2px;
}

.sponsor::-webkit-scrollbar-thumb:hover,
.social-media-icon::-webkit-scrollbar-thumb:hover,
.btn-group::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.8);
}

:global(html), :global(body) {
    overflow-x: hidden !important;
    overflow-y: auto !important;
    position: static !important;
    height: auto !important;
    width: auto !important;
}

:global(#app) {
    overflow-x: hidden !important;
    overflow-y: auto !important;
    position: static !important;
    height: auto !important;
    width: auto !important;
}

html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    overflow-y: auto;
    width: 100%;
    min-width: 320px;
}

.sponsor {
    display: flex;
    justify-content: space-around;
    margin: 20px;
    background: #222222;
    border-radius: 5px;
    padding: 10px;
    min-width: 400px;
    overflow-x: auto;
    overflow-y: hidden;
}

.input-group {
    width: 90%;
    max-width: 300px;
    display: block;
    margin: auto;
    margin-bottom: 30px;
    min-width: 280px;

    .input-wrapper {
        display: flex;
        align-items: center;
        background: #f0f0f0;
        border-radius: 8px;
        padding: 8px 12px;
        margin-bottom: 12px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        min-width: 250px;
        overflow: hidden;

        .icon {
            margin-right: 8px;
            flex-shrink: 0;
        }

        input {
            border: none;
            background: none;
            outline: none;
            font-size: 14px;
            color: #333;
            width: 100%;
            min-width: 200px;
        }
    }
}

.container-title {
    background-image: url("../assets/banner.svg");
    background-size: contain;
    background-repeat: no-repeat;
    width: 90%;
    max-width: 380px;
    min-width: 300px;
    height: 100px;
    margin: auto;
    color: #fbb03a;
    display: flex;
    justify-content: center;
    font-size: larger;
    font-weight: bold;
    margin-bottom: -50px !important;
    overflow: hidden;
}

.btn-group {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
    justify-content: center;
    min-width: 380px;
    padding: 10px;
    overflow-x: auto;
    overflow-y: hidden;

    .btn-group-left, .btn-group-right {
        display: flex;
        flex-direction: column;
        gap: 10px;
        
        .btn-left-img, .btn-right-img {
            background-size: contain;
            background-repeat: no-repeat;
            width: 180px;
            height: 50px;
            cursor: pointer;
            flex-shrink: 0;
            overflow: hidden;

            .text {
                font-weight: 900;
                font-size: 13px;
                color: black;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        .btn-left-img {
            background-image: url("../assets/btnLeft.svg");

            .text {
                text-align: left;
                margin-left: 40px;
            }
        }

        .btn-right-img {
            background-image: url("../assets/btnRight.svg");

            .text {
                text-align: right;
                margin-right: 40px;
            }
        }
    }
}

.btn-nano-guard {
    background-image: url("../assets/btnRight.svg");
    background-size: contain;
    background-repeat: no-repeat;
    width: 180px;
    height: 50px;
    margin: auto;
    cursor: pointer;
    overflow: hidden;

    .text {
        font-weight: 900;
        font-size: 13px;
        text-align: right;
        color: black;
        margin-right: 40px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

#Gaiptal {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    min-width: 320px;
    display: flex;
    background: radial-gradient(circle at center top, #C8A244 10%, black 70%);
    flex-direction: column;
    align-items: center;
    overflow-x: hidden;
    overflow-y: auto;
}

#icerik {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    min-width: 320px;
    padding: 10px;
    box-sizing: border-box;
    overflow-x: hidden;
}

#logo {
    width: 100%;
    text-align: center;
    margin-top: 0;
    background-color: transparent;
    color: white;
    font-size: 24px;
    overflow: hidden;

    img {
        width: 80%;
        max-width: 300px;
        min-width: 200px;
    }
}

#banner {
    width: 100%;
    min-width: 320px;
    height: 250px;
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 20px;
    position: relative;
    overflow: hidden;
}

.header-content {
    width: 90%;
    max-width: 500px;
    min-width: 300px;
    height: 200px;
    background-image: url("../assets/header.svg");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    text-align: center;
    padding: 20px;
    box-sizing: border-box;
    overflow: hidden;
}

.header-text-one {
    color: white;
    font-weight: bold;
    font-size: 12px;
    max-width: 300px;
    margin: 0 auto 10px auto;
    line-height: 1.4;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

.header-text-two {
    font-weight: 900;
    color: #fbbc14;
    font-size: 14px;
    max-width: 400px;
    margin: 0 auto;
    line-height: 1.3;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

.nano-sos-text {
    color: black;
    font-weight: bold;
    font-size: 20px;
    padding: 10px 20px;
    position: absolute;
    bottom: 30px;
    white-space: nowrap;
    overflow: hidden;
}

.container-wrapper {
    max-width: 500px;
    min-width: 320px;
    margin: 0 auto;
    width: 100%;
    overflow: hidden;
}

.container-header, #sari-kutu {
    max-width: 500px;
    min-width: 320px;
    width: 100%;
}

.container-header img {
    width: 100%;
    min-width: 320px;
}

#sari-kutu {
    position: relative;
    background: linear-gradient(92deg, #ffda03, #fcb814);
    margin-top: -7px;
    color: black;
    text-align: center;
    font-size: 18px;
    min-height: 100px;
    margin-bottom: 100px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    overflow-x: hidden;
    padding: 10px;
    box-sizing: border-box;

    .social-media-icon {
        width: 90%;
        max-width: 300px;
        min-width: 250px;
        margin: auto;
        display: flex;
        justify-content: center;
        padding-top: 20px;
        gap: 5px;
        overflow-x: auto;
        overflow-y: hidden;

        div {
            flex-shrink: 0;
            
            img {
                width: 30px;
                height: 30px;
                cursor: pointer;
            }
        }
    }

    .left-align, .right-align {
        flex: 1;
        text-align: center;
        margin-top: -50px;
        overflow: hidden;

        img {
            width: 100px !important;
            height: 200px !important;
        }
    }

    .center-align {
        display: flex;
        justify-content: center;
        flex: 2;
        overflow: hidden;
    }
}

@media (max-width: 1000px) {
    :global(html), :global(body) {
        overflow-x: hidden !important;
        overflow-y: auto !important;
    }

    #Gaiptal {
        background: radial-gradient(circle at center top, #C8A244 10%, black 30%);
        width: 100% !important;
        min-width: 100% !important;
        overflow-x: hidden !important;
    }
    
    #banner {
        margin-top: -40px !important;
        min-width: 100% !important;
    }
    
    .nano-sos-text {
        bottom: 0 !important;
        font-size: 16px;
        padding: 5px 10px;
    }
    
    .header-content {
        margin-top: 95px;
        height: 150px !important;
        min-width: 300px !important;

        .header-text-one {
            font-size: 9px !important;
            width: 280px;
            margin: 0 auto;
        }
        
        .header-text-two {
            font-size: 13px !important;
        }

        .header-text-three {
            font-size: 14px !important;
        }
    }
    
    .content {
        margin-top: -15px !important;
        margin-right: 10px;
        margin-left: 10px;
        width: calc(100% - 20px);
        max-width: 100%;
        overflow-x: hidden;
    }

    .btn-group {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        width: 100%;
        max-width: 400px;
        margin: 0 auto;
        padding: 10px;
        gap: 10px;
        overflow-x: auto;
        overflow-y: hidden;
        
        /* Beyaz scroll bar sadece bu alan için */
        &::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        
        &::-webkit-scrollbar-track {
            background: rgba(255, 255, 255, 0.2);
            border-radius: 2px;
        }
        
        &::-webkit-scrollbar-thumb {
            background: rgba(255, 255, 255, 0.8);
            border-radius: 2px;
        }
        
        &::-webkit-scrollbar-thumb:hover {
            background: rgba(255, 255, 255, 1);
        }

        .btn-group-left, .btn-group-right {
            display: flex;
            flex-direction: column;
            gap: 10px;
            flex: none;
            min-width: 180px;
            
            .btn-left-img, .btn-right-img {
                width: 160px;
                height: 45px;
                margin: 0 auto;
                
                .text {
                    font-size: 11px;
                    padding-top: 8px;
                }
            }
        }
    }

    .btn-nano-guard {
        width: 160px;
        height: 45px;
        margin: 20px auto 10px auto;
        
        .text {
            font-size: 11px;
            padding-top: 8px;
        }
    }

    .sponsor {
        width: calc(100% - 20px);
        margin: 10px;
        padding: 5px;
        overflow-x: auto;
        overflow-y: hidden;
    }
}

@media (max-width: 480px) {
    .header-text-one {
        font-size: 8px !important;
        width: 250px !important;
    }
    
    .header-text-two {
        font-size: 11px !important;
    }
    
    .nano-sos-text {
        font-size: 14px;
    }
    
    .btn-group {
        max-width: 350px;
        gap: 8px;
        
        .btn-group-left, .btn-group-right {
            gap: 8px;
            min-width: 160px;
            
            .btn-left-img, .btn-right-img {
                width: 150px;
                height: 40px;
                
                .text {
                    font-size: 10px;
                    padding-top: 6px;
                }
            }
        }
    }
    
    .btn-nano-guard {
        width: 150px;
        height: 40px;
        
        .text {
            font-size: 10px;
            padding-top: 6px;
        }
    }
    
    .sponsor {
        flex-wrap: nowrap;
        gap: 5px;
        margin: 5px;
        overflow-x: auto;
        overflow-y: hidden;
        
        img {
            width: 70px !important;
            flex-shrink: 0;
        }
    }
}

@media (max-width: 375px) {
    #logo img {
        width: 45%;
        max-width: 140px;
    }
    
    .header-content {
        height: 80px !important;
        padding: 5px;
    }
    
    .header-text-one {
        font-size: 5px !important;
        width: 180px !important;
    }
    
    .header-text-two {
        font-size: 7px !important;
    }
    
    .btn-group {
        max-width: 280px;
        gap: 4px;
        
        .btn-group-left, .btn-group-right {
            gap: 4px;
            
            .btn-left-img, .btn-right-img {
                width: 110px;
                height: 25px;
                
                .text {
                    font-size: 6px;
                    padding-top: 2px;
                }
            }
        }
    }
    
    .btn-nano-guard {
        width: 110px;
        height: 25px;
        
        .text {
            font-size: 6px;
            padding-top: 2px;
        }
    }
    
    .container-title {
        height: 40px;
        margin-bottom: -20px !important;
        
        span {
            font-size: 9px;
        }
    }
    
    .social-media-icon div img {
        width: 16px !important;
        height: 16px !important;
    }
    
    .sponsor img {
        width: 35px !important;
    }
}
</style>